<template>
  <div :class="cardClasses">
    <div v-if="$slots.header || title" class="px-6 pt-6 pb-0">
      <slot name="header">
        <div class="flex items-start justify-between gap-4">
          <div>
            <h3 v-if="title" class="text-h5">{{ title }}</h3>
            <p v-if="description" class="text-caption mt-1">{{ description }}</p>
          </div>
          <slot name="actions" />
        </div>
      </slot>
    </div>
    <div :class="bodyClasses">
      <slot />
    </div>
    <div v-if="$slots.footer" class="px-6 pb-6 pt-0 border-t border-white/30 dark:border-white/10 mt-4 pt-4">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    title: String,
    description: String,
    hover: { type: Boolean, default: false },
    padding: { type: Boolean, default: true },
    glass: { type: Boolean, default: true },
  },
  computed: {
    cardClasses() {
      return [
        'rounded-xl transition-all duration-300',
        this.glass !== false ? 'glass-card' : 'border border-border bg-surface shadow-card',
        this.hover && 'hover:shadow-glass-lg hover:border-primary/25 hover:-translate-y-0.5',
      ]
    },
    bodyClasses() {
      return this.padding ? 'p-6' : ''
    },
  },
}
</script>
